__turbopack_context__.v({
  "actionButtons": "Section-module__MySK5W__actionButtons",
  "sectionContainer": "Section-module__MySK5W__sectionContainer",
  "sectionContainer--spacious": "Section-module__MySK5W__sectionContainer--spacious",
});
